// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"46581f79","399":"b365b517"}[chunkId] + ".chunk.js";
};